import React from "react";

const FileIcon = () => {
  return <img src="/icons/file.svg" alt="Download" />;
};

export default FileIcon;
